import React, { Fragment } from "react";
import { useI18next, useTranslation } from "gatsby-plugin-react-i18next";
import {
  StyledSection,
  StyledSectionInner,
  StyledHeadingWrapper,
  StyledFigure,
  StyledBottle,
  StyledBottleBlur,
  StyledBottleReflection,
  StyledSmoke,
  StyledList,
  StyledItem,
  StyledItemFigure,
  StyledSubtitle,
  StyledDescription,
  StyledDivider,
} from "./Products.styled";
import { theme } from "../../../style/theme";
import { InfoText } from "../../../data/types/InfoText";
import bottle from "../../../assets/images/bottle.png";
import reflection from "../../../assets/images/bottle-reflection.png";
import smoke from "../../../assets/images/smoke-1.png";
import { Heading } from "../../general/Heading/Heading";
import Divider from "../../general/Divider/Divider";

export interface ProductsProps {
  list: Array<InfoText>;
}

export const Products: React.FC<ProductsProps> = ({ list }) => {
  const { t } = useTranslation();
  const { language } = useI18next();
  const key = language === "en-us" ? "" : "home_";

  return (
    <StyledSection>
      <StyledSectionInner>
        <StyledHeadingWrapper>
          <Heading
            type="h2"
            color={theme.colors.magenta}
            textTransform="uppercase"
          >
            {t(`${key}menu.products`)}
          </Heading>
          <Divider />
        </StyledHeadingWrapper>
        <StyledList>
          {list.map(({ title, subtitle, description }, index) => (
            <Fragment key={title}>
              <StyledItem>
                <Heading
                  type="h3"
                  color={theme.colors.magenta}
                  textTransform="uppercase"
                >
                  {title}
                </Heading>
                <StyledSubtitle>{subtitle}</StyledSubtitle>
                <StyledDivider direction={index === 0 ? "left" : "right"} />
                <StyledDescription>{description}</StyledDescription>
              </StyledItem>
              {index === 0 && (
                <StyledItemFigure>
                  <StyledFigure>
                    <StyledSmoke src={smoke} alt={`smoke`} />
                    <StyledBottleReflection
                      src={reflection}
                      alt={`bottle reflection`}
                    />
                    <StyledBottle src={bottle} alt={`bottle`} />
                    <StyledBottleBlur src={bottle} alt={`bottle blur`} />
                  </StyledFigure>
                </StyledItemFigure>
              )}
            </Fragment>
          ))}
        </StyledList>
      </StyledSectionInner>
    </StyledSection>
  );
};
